import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import useNotifications from '../../../hooks/useNotifications';
import DuplicateIcon from '../../../icons/duplicate2.svg';
import { match } from 'ts-pattern';
import { Locale } from '../../Translate';
import Text from '../Text';

import './LinkPreview.scss';

function LinkPreview(props) {
  const {
    children,
    feedbackMessage = 'The URL has been copied',
    showCopyButton = true,
    placeholder,
    loadingText,
    isLoading,
    isError,
    errorText,
  } = props;
  const { showNotice } = useNotifications();

  const onButtonClick = useCallback(() => showNotice({ message: feedbackMessage, type: 'info' }), [
    showNotice,
    feedbackMessage,
  ]);

  return (
    <div styleName="container">
      {match({
        isError,
        hasResult: !!children,
        isLoading,
        hasLoadingText: !!loadingText,
        hasPlaceholder: !!placeholder,
      })
        // Backwards compatibility special case
        .with(
          {
            isError: false,
            hasLoadingText: false,
            hasPlaceholder: false,
            hasResult: true,
          },
          () => <Text styleName="link">{children}</Text>
        )
        // Normal cases
        .with({ isError: true }, () => (
          <Text styleName="link error-text">
            <Locale>{errorText || 'An error occurred'}</Locale>
          </Text>
        ))
        .with({ hasResult: true }, () => <Text styleName="link">{children}</Text>)
        .with({ isLoading: true }, () => (
          <Text>
            <Locale>{loadingText}</Locale>
          </Text>
        ))
        .otherwise(() => (
          <Text>
            <Locale>{placeholder}</Locale>
          </Text>
        ))}
      {showCopyButton && (
        <CopyToClipboard text={children}>
          <button styleName="copy-button" aria-label="Copy" onClick={onButtonClick}>
            <DuplicateIcon styleName="icon" />
          </button>
        </CopyToClipboard>
      )}
    </div>
  );
}

LinkPreview.propTypes = {
  children: PropTypes.string,
  feedbackMessage: PropTypes.string,
};

export default React.memo(LinkPreview);
